(function mpStepsAnchor() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'mp_steps-anchor';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  $(() => {
    const $compBlock = $('.mp-steps-anchor');
    const $compBlockHolder = $('.mp-steps-anchor__holder');
    const $compDotBlock = $('.mp-steps-anchor__item-dot');
    const $compFixedTrigger = $('#mp-steps-anchor__mark');
    const $headerBlock = $('#header-anchor');
    const $messageBannerBlock = $('.comp-message-banner');

    const headerBlockHeight = $headerBlock.outerHeight() || 0;
    const messageBlockHeight =
      $messageBannerBlock.length > 0 ? $messageBannerBlock.outerHeight() : 0;
    const fullHeaderHeight = headerBlockHeight + messageBlockHeight;

    const pxToNumberValue = (stringValue) => Number(stringValue.replace('px', ''));

    const compBlockMarginTop = pxToNumberValue($compBlock.css('margin-top'));
    const compDotBlockMarginTop = pxToNumberValue($compDotBlock.css('margin-top'));

    function calculateHeaderHeight() {
      const messageBannerHeight = isCompExists('message-banner')
        ? $('.message-banner').innerHeight()
        : 0;
      const headerHeight = isCompExists('header') ? $('#header-anchor').innerHeight() : 0;

      return headerHeight + messageBannerHeight;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          $compBlock.removeClass('is-fixed');
        } else {
          $compBlock.addClass('is-fixed');
          $compBlock.css('top', `${fullHeaderHeight - compBlockMarginTop}px`);
        }
      },
      {
        rootMargin: `-${fullHeaderHeight + compDotBlockMarginTop}px`,
      },
    );

    observer.observe($compFixedTrigger[0]);

    const anchorSectionIntersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        const $listAnchorLinkSection = $compBlock.find(`[href='#${entry.target.id}'`).parent();

        if (!entry.isIntersecting) {
          if (entry.boundingClientRect.top > calculateHeaderHeight()) return;
          $listAnchorLinkSection.addClass('active');
        } else {
          entry.boundingClientRect.top > 0 && $listAnchorLinkSection.removeClass('active');
        }
      },
      {
        rootMargin: `-${fullHeaderHeight + compDotBlockMarginTop + $compBlock.innerHeight()}px`,
      },
    );

    $compBlockHolder
      .parent()
      .find('[id^="anchor"]')
      .each((i, el) => {
        anchorSectionIntersectionObserver.observe(el);
      });

    $compBlockHolder
      .parent()
      .find('[id^="anchor"]')
      .css('scroll-margin-top', calculateHeaderHeight() - 7);
  });
})();
